import { types } from '../types'

const initialState = {
  waiting: false,
  success: false,
  error: '',
  successGetTeamMember: false,
  list: { data: [] },

  waitingUpdate: false,
  successUpdate: false,
  errorUpdate: false,

  waitingDeleted: false,
  successDeleted: false,
  errorDeleted: false,
}

const teamMemberReducer = (state = initialState, { type, action, error }) => {
  switch (type) {
    case types.GET_TEAM_PANEL_MEMBERS_REQUEST: {
      return {
        ...state,
        waiting: true,
        successGetTeamMember: false,
        displayToast: false,
        list: null


      }
    }
    case types.GET_TEAM_PANEL_MEMBERS_SUCCESS: {
      return {
        ...state,
        waiting: false,
        successGetTeamMember: true,
        list: action?.data,
      }
    }
    case types.GET_TEAM_PANEL_MEMBERS_ERROR: {
      return {
        ...state,
        waiting: false,
        error: error?.response?.data?.message,
      }
    }

    case types.ADD_MEMBER_REQUEST: {
      return {
        ...state,
        waiting: true,
        success: false,
      }
    }
    case types.ADD_MEMBER_SUCCESS: {
      return {
        ...state,
        waiting: false,
        success: true,
      }
    }
    case types.ADD_MEMBER_ERROR: {
      return {
        ...state,
        waiting: false,
        error: error?.response?.data?.message,
      }
    }

    case types.DELETE_MEMBER_REQUEST: {
      return {
        ...state,
        waitingDeleted: true,
        successDeleted: false,
        errorDeleted: false,
      }
    }
    case types.DELETE_MEMBER_SUCCESS: {
      return {
        ...state,
        waitingDeleted: false,
        successDeleted: true,
        errorDeleted: false,
      }
    }
    case types.DELETE_MEMBER_ERROR: {
      return {
        ...state,
        waitingDeleted: false,
        successDeleted: false,
        errorDeleted: error?.data?.title ? error?.data?.title : { generalError: true },
      }
    }

    case types.UPDATE_MEMBER_REQUEST: {
      return {
        ...state,
        waitingUpdate: true,
        successUpdate: false,
        errorUpdate: false,
      }
    }
    case types.UPDATE_MEMBER_SUCCESS: {
      return {
        ...state,
        waitingUpdate: false,
        successUpdate: true,
        errorUpdate: false,
      }
    }
    case types.UPDATE_MEMBER_ERROR: {
      return {
        ...state,
        waitingUpdate: false,
        successUpdate: false,
        errorUpdate: true,
        // error: error.response.data.message,
      }
    }

    case types.MEMBER_RESET_PROPS: {
      return {
        ...state,
        waiting: false,
        success: false,
        error: '',
        successGetTeamMember: false,

        waitingUpdate: false,
        successUpdate: false,
        errorUpdate: false,

        waitingDeleted: false,
        successDeleted: false,
        errorDeleted: false,
      }
    }
    default:
      return state
  }
}

export default teamMemberReducer
